"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGameOverState = exports.isGameOver = void 0;
const board_1 = require("../board");
const constants_1 = require("../constants");
const Model_1 = require("../Model");
const players_1 = require("../players");
const isGameOver = (state) => (0, board_1.countAtPoint)(state.board, Model_1.WHITE, Model_1.OFF_POINT) === constants_1.TOTAL_CHECKERS ||
    (0, board_1.countAtPoint)(state.board, Model_1.BLACK, Model_1.OFF_POINT) === constants_1.TOTAL_CHECKERS;
exports.isGameOver = isGameOver;
const getGameOverState = (state) => {
    if (!(0, exports.isGameOver)(state)) {
        throw new Error('Game is not over');
    }
    const winner = (0, board_1.countAtPoint)(state.board, Model_1.WHITE, Model_1.OFF_POINT) === constants_1.TOTAL_CHECKERS
        ? Model_1.WHITE
        : Model_1.BLACK;
    const loser = (0, players_1.opponent)(winner);
    const isBackgammon = Math.max(...(0, board_1.getPointsWithAtLeast)(state.board, loser, 1)) >
        constants_1.BACKGAMMON_POINT_THRESHOLD;
    const isGammon = (0, board_1.countAtPoint)(state.board, loser, Model_1.OFF_POINT) === 0;
    const winType = isBackgammon ? 'backgammon' : isGammon ? 'gammon' : 'normal';
    return {
        state: 'game-over',
        winner,
        winType,
    };
};
exports.getGameOverState = getGameOverState;
